import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';

export const isViewOrderBrandRefresh = () => isBrandRefreshEnabled();

export const getViewOrderRegionProps = () =>
  isBrandRefreshEnabled() ? { 'data-region': 'edit-order' } : {};

export const getViewOrderPartProps = part =>
  isBrandRefreshEnabled() ? { 'data-part': part } : {};

export const getViewOrderItemCount = items => {
  const list = items || [];
  if (!isBrandRefreshEnabled()) {
    return list.length;
  }

  return list.reduce((sum, item) => {
    const qty = parseInt(item && item.quantity, 10);
    return sum + (Number.isNaN(qty) ? 0 : qty);
  }, 0);
};

export const getViewOrderItemCountLabel = items =>
  `${getViewOrderItemCount(items)} Item Order`;

export const getViewOrderTotalsLabel = label => {
  if (!isBrandRefreshEnabled()) {
    return label;
  }

  if (label === 'Subtotal') {
    return 'Sub Total';
  }

  if (label === 'Taxes & Fees') {
    return 'Tax';
  }

  return label;
};
